'use client';

import { useAuth } from 'react-oidc-context';
import styled from 'styled-components';

import { Flex, Modal } from '@zoomit/primitives';
import { theme } from '@zoomit/zoomit-ds';

import { useArticleBookmarks } from '../../hooks/useArticleBookmarks';
import type { BookmarksModalState } from '../../types/articles';
import type { AuthorType } from '../../types/shared';
import ArticleBookmarksModal, { ArticleBookmarkHeader } from './ArticleBookmarksModal';

type Props = {
  modal: BookmarksModalState;
  setModal: (modal: BookmarksModalState) => void;
  articleBookmarkStatus?: string[];
  articleId?: string;
  authors?: AuthorType[];
};

const ArticleDesktopBookmarkModal = (props: Props) => {
  const { modal, setModal, articleBookmarkStatus = [], articleId, authors } = props;
  const { isAuthenticated } = useAuth();

  const { data: bookmarkList } = useArticleBookmarks({
    initialList: [],
    enabled: isAuthenticated,
  });

  const closeModal = () => setModal(null);

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Modal size={modal === 'bookmark-list' ? 'md' : 'sm'} onClose={closeModal} isOpen={modal !== null}>
        <ArticleBookmarksWrapper
          isLarge={modal === 'bookmark-list'}
          flexDirection="column"
          spacing={{ px: 'x6', pt: 'x5' }}
        >
          <ArticleBookmarkHeader
            closeModal={closeModal}
            title={modal === 'bookmark-list' ? 'مدیریت بوک‌مارک‌ها' : 'حذف لیست'}
          />
          <ArticleBookmarksModal
            authors={authors}
            bookmarkedItems={articleBookmarkStatus}
            articleId={articleId}
            bookmarkList={bookmarkList || []}
            modal={modal}
            closeModal={closeModal}
            openDeleteModal={() => setModal('remove-bookmark')}
            openListModal={() => setModal('bookmark-list')}
          />
        </ArticleBookmarksWrapper>
      </Modal>
    </div>
  );
};

export default ArticleDesktopBookmarkModal;

const ArticleBookmarksWrapper = styled(Flex)<{ isLarge: boolean }>`
  width: 100%;
  background: var(${theme.background2});
  height: ${({ isLarge }) => (isLarge ? '56rem' : 'auto')};
`;
